import { FuseRouteConfigType } from '@fuse/utils/FuseUtils';
import authRoles from '../authRoles';
import PetRegisterSubscription from '../SignUpFlow/PetFlow/PetRegisterSubscription';
import PetRegistrationComplete from '../SignUpFlow/PetFlow/PetRegistrationComplete';

const RecoverPlanSelectConfig: FuseRouteConfigType = {
	settings: {
		layout: {
			config: {
				navbar: { display: false },
				toolbar: { display: false },
				footer: { display: false },
				leftSidePanel: { display: false },
				rightSidePanel: { display: false }
			}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: 'recover/plan-select/:id',
			element: <PetRegisterSubscription />
		},
		{
			path: 'recover/payment-complete',
			element: <PetRegistrationComplete />
		}
	]
};

export default RecoverPlanSelectConfig;
